import {generateSystems} from '@product-web/shared--accounting-systems'

export function useAccountingSystemDetails(accountingSystemName: string) {
    const systemName = accountingSystemName.includes(':custom')
        ? accountingSystemName.split(':')[0]
        : accountingSystemName
    return generateSystems()[systemName]
}
